class AltStores extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const cta = event.target.closest('.alt-stores__cta');

    if (!cta) return;

    const stores = this.querySelector('.alt-stores');

    if (!stores) return;

    stores.classList.toggle('alt-stores--active');
    cta.classList.toggle('alt-stores__cta--active');
  };
}

customElements.define('alt-stores', AltStores);
